/**
 * React's error boundaries only catch throws during render/commit of the
 * components they wrap. They cannot see: errors thrown outside that lifecycle
 * (event handlers, timers, async callbacks), or unhandled promise rejections
 * - notably the ones `document.startViewTransition()` produces, which
 * `useRevealSwap` drives on Plan, Snapshot, and Community. An error in either
 * category currently vanishes with no boundary fallback and no log line.
 *
 * Message is trimmed and the raw error/reason is never logged, matching
 * RootErrorBoundary's redaction posture.
 */
export function initGlobalErrorReporting(target: Window = window): void {
  target.addEventListener("error", (event) => {
    logUncaughtError("ui_uncaught_error", event.error, event.message);
  });
  target.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason);
    logUncaughtError("ui_unhandled_rejection", reason instanceof Error ? reason : null, message);
  });
}

function logUncaughtError(event: string, error: Error | null, rawMessage: string): void {
  const name = error?.name ?? "[unknown]";
  const message = typeof rawMessage === "string" ? rawMessage.slice(0, 240) : "[unknown]";
  // eslint-disable-next-line no-console
  console.error(JSON.stringify({ event, name, message }));
}
